export default __webpack_public_path__ + "media/Beverage-Fresh-Juice.d2395a5f.png";